<template>
  <v-dialog v-model="showDialog" :persistent="loading" :max-width="1200">
    <v-card>
      <div class="w-100">
        <div class="text-left pl-3 bg-black text-white">
          {{ title }}
        </div>
        <div class="text-right mt-n6 mr-1 pl-3 bg-black text-white">
          <v-icon
            v-if="!loading"
            size="20"
            color="#fff"
            @click="showDialog = false"
            >mdi-close-circle</v-icon
          >
        </div>
        <v-row v-if="!loading" class="ma-0 ml-md-1 mr-md-1">
          <v-col cols="12" md="6">
            <v-simple-table dense>
              <template #default>
                <thead class="custom-table-bordered">
                  <tr>
                    <td class="bg-gray">Facturacion total</td>
                    <td class="text-black">
                      {{ formatNumber(data[billingTotalKeyValue], '$', 0) }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ subTitle }}</td>
                    <td class="text-black bg-gray">
                      {{ formatNumber(data[billingNewKeyValue], '$', 0) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-gray">% {{ subTitle }}</td>
                    <td class="text-black">
                      {{ formatFloat(data[billingNewPercentKeyValue]) }}%
                    </td>
                  </tr>
                </thead>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="12 mt-n6">
            <v-simple-table dense>
              <template #default>
                <thead>
                  <tr class="font-weight-bold bg-white text-dark table-heading">
                    <th colspan="9" class="text-center text-dark">
                      <b>{{ subTitle }}</b>
                    </th>
                  </tr>
                  <tr class="custom-tr-no-bordered">
                    <th colspan="2" class="text-center text-dark">
                      <b>Grupo material</b>
                    </th>
                    <th
                      v-for="(period, index) in periods"
                      :key="index"
                      class="text-center text-dark"
                    >
                      <div class="d-flex flex-row align-center">
                        <b class="pre-line text-nowrap">
                          {{ period.month }}
                        </b>
                        <sort-by-button
                          class="w-100 mb-0"
                          :data="products"
                          :column="`billingOrder${period.order}`"
                          type="number"
                          icon-up="mdi-arrow-up"
                          icon-down="mdi-arrow-down"
                          @sortedData="products = $event"
                        />
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody class="border border-1">
                  <tr
                    v-for="(row, index) in products"
                    :key="index"
                    class="custom-tr-no-bordered"
                  >
                    <td
                      colspan="2"
                      class="border-bottom-0 text-left text-nowrap"
                    >
                      <span class="font-weight-bold">
                        {{ index + 1 }}
                      </span>
                      {{ `${row.material_id} - ${row.name} ` }}
                    </td>
                    <td
                      v-for="(month, index) in periods"
                      :key="index"
                      class="border-bottom-0"
                    >
                      {{
                        formatNumber(row[`billingOrder${month.order}`], '$', 0)
                      }}
                    </td>
                  </tr>
                  <tr class="font-weight-bold">
                    <td colspan="2">Total</td>
                    <td v-for="(item, index) in periods" :key="index">
                      {{ formatNumber(item.billing, '$', 0) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <div class="text-disabled mt-5">
              Cargando información por favor espere...
            </div>
            <v-progress-linear
              indeterminate
              color="primary darken-2"
            ></v-progress-linear>
          </v-col>
        </v-row>
      </div>
      <alert-prominent v-if="error" :message="error" :dismissible="true" />
    </v-card>
  </v-dialog>
</template>

<script>
  import MixinService from '@/mixins/service';
  import numbersFormats from '@/mixins/numbersFormats';
  import AlertProminent from '@/components/AlertProminent.vue';
  import SortByButton from '@/components/SortByButton.vue';

  export default {
    name: 'NewProducts',
    components: { AlertProminent, SortByButton },
    mixins: [MixinService, numbersFormats],
    props: {
      loading: {
        type: Boolean,
        default: true,
      },
      data: {
        type: Object,
        required: true,
      },
      title: {
        type: String,
        default: 'Facturacion de productos Gen. N',
      },
      subTitle: {
        type: String,
        default: 'Facturacion de productos Nuevos',
      },
      error: {
        type: String,
        default: 'Facturacion de productos Gen. N',
      },
      value: {
        type: Boolean,
        default: false,
      },
      billingTotalKeyValue: {
        type: String,
        default: 'totalBilling',
      },
      billingNewKeyValue: {
        type: String,
        default: 'billing',
      },
      billingNewPercentKeyValue: {
        type: String,
        default: 'billingPercentage',
      },
      listKeyValue: {
        type: String,
        default: 'items',
      },
      periodKey: {
        type: String,
        default: 'periods',
      },
    },
    data() {
      return {
        months: [],
        products: [],
      };
    },
    computed: {
      periods() {
        return this.getNestedValue(this.data, this.periodKey);
      },
      showDialog: {
        set(value) {
          this.$emit('input', value);
        },
        get() {
          return this.value;
        },
      },
    },
    watch: {
      data() {
        this.products = this.getNestedValue(this.data, this.listKeyValue);
      },
    },
    created() {
      this.months = this.calcularUltimosMeses(7);
    },

    methods: {
      dateFormat(date) {
        return this.removeTimeFromDate(
          date,
          this.inputDateFormat,
          this.outputDateFormat
        );
      },
      getNestedValue(obj, path) {
        if (!obj || typeof path !== 'string') return '';
        try {
          const result = path
            .split('.')
            .reduce(
              (acc, key) =>
                acc && acc[key] !== undefined ? acc[key] : undefined,
              obj
            );
          return result !== undefined ? result : [];
        } catch (e) {
          return e;
        }
      },
    },
  };
</script>
<style scoped>
  .table-heading {
    border-width: 1px 1px 3px 1px;
    border-color: rgb(228, 231, 234);
    border-bottom-color: rgb(112, 112, 112);
  }

  .custom-table-bordered {
    border-width: 2.5px;
    border-color: rgb(224, 228, 232);
  }

  .custom-table-bordered > tr > td {
    border-width: 2.5px;
    border-color: rgb(224, 228, 232);
  }

  .custom-table-bordered > th {
    border-width: 2.5px;
    border-color: rgb(224, 228, 232);
  }

  .border-bottom-0 {
    border-bottom: 0px;
  }

  .custom-tr-no-bordered {
    border-width: 0px 1px 0px 1px;
    border-color: lightgray;
  }
</style>
